import React, { Fragment } from 'react';
import eventManager from 'helpers/eventManager';
// import { Detector } from 'react-detect-offline';
import i18n from 'i18next';
// import { ApiErrorModal, Belt, Icon, Button } from 'Components';
import { ApiErrorModal } from 'Components';
import history from 'src/history';
import './NotifyContainer.css';


class NotifyContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      content: '',
    };
  }

  componentDidMount() {
    eventManager.on('notification-show', (content, options) => this.show(content, options));
  }

  componentWillUnmount() {
    eventManager.off('notification-show');
  }

  show(content) {
    this.error(content);
  }

  error(content = i18n.t('common:sessionTimeOut')) {
    this.setState({
      showError: true,
      content,
    });
  }

  close() {
    this.setState({
      showError: false,
    });
  }

  render() {
    return (
      <Fragment>
        { this.state.showError &&
          <ApiErrorModal
            show
            errorMessage={this.state.content}
            hidePageUnavailableDescription
            isCloseable
            onCloseClick={() => this.setState({ showError: false, content: '' }, () => history.push('/login'))}
          />
          }
        {/* <Detector
          render={({ online }) => (
            <Fragment>
              {(!online) && (
              <Belt className="offline-notify-banner">
                <h2>{i18n.t('common:offlineConnection')}</h2>
                <Button onClick={() => window.location.reload()}>
                  <Icon icon="refresh" />
                </Button>
              </Belt>
              )}
            </Fragment>
          )}
        /> */}
      </Fragment>
    );
  }
}

export default NotifyContainer;



// WEBPACK FOOTER //
// ./src/components/Notify/NotifyContainer.jsx